import { Theme } from "@mui/material";

import { getColor } from "@hooks";
import { WorkingArea } from "@utils";

export const workingAreaToBaseColorDict = (
  theme: Theme,
): Record<WorkingArea, string> => ({
  embedded: getColor(c => c.tokens.casestudy.embedded.base, theme),
  automation: getColor(c => c.tokens.casestudy.automation.base, theme),
  agile: getColor(c => c.tokens.casestudy.agile.base, theme),
});
